module.exports = __webpack_public_path__ + "static/pic03-2c7e7a65aee64f9c21cb45a883fc9ffc.jpg";